import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
/**
 * Show the children of this component after a delay.
 *
 * @param props.delay number of milliseconds before showing the children
 */
export function ShowAfterDelay(props) {
    const [showChildren, setShowChildren] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowChildren(true);
        }, props.delay);
        return () => clearTimeout(timer);
    }, [props.delay]);
    if (!showChildren) {
        return null;
    }
    return _jsx(_Fragment, { children: props.children });
}
